<template>
  <li class="copy-list-item">
    <number-highlight
      class="copy-list-item__number"
      :list-animation-start="isListInViewport"
    >
      <span class="copy-list-item__number-inner">{{ number }}</span>
    </number-highlight>
    <text-with-line-highlight
      class="copy-list-item__title"
      :list-animation-start="isListInViewport"
      :text-html="title"
      @next="nextAnimation"
    >
      <span class="copy-list-item__title-line" />
    </text-with-line-highlight>
    <text-highlight
      :list-animation-start="canBePlayed(index)"
      :delay-animation="true"
      :key="index"
      :text-html="text"
      v-for="(text, index) in texts"
      @next="nextAnimation"
    />
  </li>
</template>
<script>
import inViewport from 'vue-in-viewport-mixin'
import TextHighlight from '@/components/TextHighlightAnimation/TextHighlight'
import TextWithLineHighlight from '@/components/TextHighlightAnimation/TextWithLineHighlight'
import NumberHighlight from '@/components/TextHighlightAnimation/NumberHighlight'

export default {
  components: {
    TextHighlight,
    TextWithLineHighlight,
    NumberHighlight
  },
  mixins: [inViewport],
  props: {
    title: {
      type: String,
      default: ''
    },
    number: {
      type: String,
      default: ''
    },
    texts: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      isListInViewport: false,
      currentAnimation: -1
    }
  },
  computed: {
    canBePlayed () {
      return index => index <= this.currentAnimation
    }
  },
  watch: {
    'inViewport.fully' (visible) {
      if (visible) {
        this.isListInViewport = true
      }
    },
    'inViewport.now' (visible) {
      if (!visible) {
        this.isListInViewport = false
        this.currentAnimation = -1
      }
    }
  },
  methods: {
    nextAnimation () {
      this.currentAnimation += 1
    }
  }
}
</script>
<style lang="scss" scoped>
  .copy-list-item {
    &:not(:last-of-type) {
      margin-bottom: 60px;
      @include media-up(sm) {
        margin-bottom: 70px;
      }
    }
    &__number {
      @include font-style-medium-smaller;
      @include font-cut;
      line-height: 0.95em;
      &-inner {
        position: relative;
      }
    }
    &__title {
      position: relative;
      @include font-style-medium;
      padding-top: 1.4em;
      margin-top: 0;
      text-transform: uppercase;
    }
    .text-highlight {
      @include media-down(sm) {
        font-size: 14px;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/CopyListItem.vue